export const getRegionName = (data) => {
  let region_code;
  data.value ? (region_code = data.value) : (region_code = data);
  // Certain DB tables contain whitespace-surrounded region names
  region_code = region_code.trim();

  switch (region_code) {
    default:
      return region_code;
    case '1 - EASTERN':
      return 'Eastern';
    case '2 - SOUTHERN':
      return 'Southern';
    case '3 - CENTRAL':
      return 'Central';
    case '4 - SOUTHWEST':
      return 'Southwest';
    case '5 - WESTERN':
      return 'Western';
    case '9 - HEADQUARTERS':
      return 'Headquarters';
  }
};

// Note: LOC case types don't appear on the legacy site, but they exist in the data so I left them in this object
export const case_abbrevs = {
  cao: 'Corrective Action Order',
  nopv: 'Notice of Probable Violation',
  noa: 'Notice of Amendment',
  wl: 'Warning Letter',
  pso: 'Notice of Proposed Safety Order',
  loc: 'Letter of Concern',
};

// Note: there are a ton of order types in the SQL. For now, I just included those used on the currently created pages
// TODO: this remapping is no longer needed
export const order_abbrevs = {
  cao: 'Corrective Action Order',
  fo: 'Final Order',
  co: 'Consent Order',
  oda: 'Order Directing Amendment',
  so: 'Safety Order',
  dop: 'Decision on Petition',
  other: 'Other Order',
  urlAbbrevs: {
    cao: 'cao',
    fo: 'fo',
    co: 'co',
    oda: 'oda',
    so: 'so',
    dop: 'dop',
    other: 'other',
  },
};

export const decodeAbbreviation = (str) => {
  let abbrev = str.toLowerCase();

  if (abbrev in case_abbrevs) {
    return case_abbrevs[abbrev];
  }

  if (abbrev in order_abbrevs) {
    return order_abbrevs[abbrev];
  }

  return str;
};
